// Optional numeric fields arrive empty, and a bare parseFloat turns those into
// NaN. The payload doubles as the Selected list entry, so a NaN comes back as
// the form's own value on the next edit and renders as "$ NaN".
const toNumber = value => {
  const parsed = Number.parseFloat(value);
  return Number.isFinite(parsed) ? parsed : undefined;
};

const toFormulationNumber = value => {
  const normalized = String(value)
    .trim()
    .replace(/%$/, '');
  if (!/^-?(?:\d+(?:\.\d+)?|\.\d+)$/.test(normalized)) return 0;
  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : 0;
};

const FORMULATION_FIELDS = [
  'N',
  'P',
  'K',
  'Ca',
  'Mg',
  'S',
  'Fe',
  'Cu',
  'Mn',
  'Zn',
  'B',
  'Mo',
  'Cl'
];

export const buildMasterlistProductPayload = values => ({
  productId: values.productId ?? values.id,
  averagePricePerUnit: toNumber(values.averagePricePerUnit),
  averagePricePerUnitUnit: values.averagePricePerUnitUnit,
  ...(!values?.packageWeight
    ? {}
    : { packageWeight: toNumber(values?.packageWeight) })
});

// Service products carry no formulation at all, so the field can be absent.
export const parseFormulation = (formulation = {}) =>
  Object.keys(formulation ?? {}).reduce(
    (result, k) => ({
      ...result,
      [k]: toFormulationNumber(formulation[k])
    }),
    {}
  );

export const buildCustomProductPayload = values => ({
  id: values.id ?? values.productId,
  name: values.name,
  manufacturer: values.manufacturer,
  standardUnit: values.standardUnit,
  type: values.type,
  makeUp: values.makeUp,
  density: toNumber(values.density),
  stdFactor: toNumber(values.stdFactor) ?? (values.isNew ? 1 : undefined),
  stdPackageUnit: values.standardUnit,
  formulation:
    values.type === 'FERTILIZER'
      ? Object.fromEntries(
          FORMULATION_FIELDS.map(field => [
            field,
            toFormulationNumber(values.formulation?.[field])
          ])
        )
      : {},
  averagePricePerUnit: toNumber(values.averagePricePerUnit),
  averagePricePerUnitUnit: values.averagePricePerUnitUnit,
  ...(values.makeUp === 'LIQUID' && values.densityInLbsPerGallon != null
    ? { densityInLbsPerGallon: toNumber(values.densityInLbsPerGallon) }
    : {})
});
